export default "__VITE_ASSET__c19eb4f8__"